"use client";

import { useRef, useState } from "react";
import Image from "next/image";

import * as Lucide from "lucide-react";
import { useInView } from "framer-motion";

import { AnimatedNumber } from "@/components/motion-primitives/animated-number";
import { Badge } from "@/components/ui/badge";
import { siteConfig } from "@/lib/siteConfig";

export default function HeroComponent() {
  const [stats, setStats] = useState([
    { number: 0, label: "Years Experience", Icon: Lucide.Building2 },
    { number: 0, label: "Industry Sectors", Icon: Lucide.Target },
    { number: 0, label: "Trusted Clients", Icon: Lucide.Users },
    { number: 0, label: "Global Locations", Icon: Lucide.Globe },
  ]);

  const ref = useRef<HTMLDivElement>(null);
  const isInView = useInView(ref);

  if (isInView && stats.every((stat) => stat.number === 0)) {
    setStats(siteConfig.getStats);
  }

  return (
    <section
      className={"wrapper hero py-4 min-h-fit"}
      style={{
        maskImage:
          "linear-gradient(to right, transparent 0%, black 10%, black 90%, transparent 100%)", // Added mask for fading edges
        WebkitMaskImage:
          "linear-gradient(to right, transparent 0%, black 10%, black 90%, transparent 100%)", // Added for Safari compatibility
      }}
    >
      <div className={"flex flex-col gap-5 items-center text-center"}>
        <Badge>About VisionTech Trading </Badge>
        <Image
          src={"/new_logo.png"}
          alt={"logo"}
          width={350}
          height={250}
          className={"rounded dark:bg-white square-gradient-bg"}
        />
        <h1
          className={
            "text-[45px] font-bold bg-gradient-to-r from-primary via-primary/90 to-emerald-400 bg-clip-text text-transparent"
          }
        >
          Pioneering Technology <br /> Trading
        </h1>
        <p
          className={"text-accent-foreground text-xl lg:w-[65%] font-semibold"}
        >
          Leading Bhutan&apos;s technological advancement through innovative
          solutions and strategic partnerships across multiple industries.
        </p>
        <div ref={ref} className="grid grid-cols-2 md:grid-cols-4 gap-4">
          {stats.map((stat) => (
            <span
              key={stat.label}
              className={"flex flex-col items-center gap-4"}
            >
              <div className={"bg-primary/10 rounded p-8"}>
                <stat.Icon className={"size-8 text-primary "} />
              </div>
              {/*<h3 className={"text-4xl font-extrabold"}>{stat.number}</h3>*/}
              <AnimatedNumber
                className="inline-flex items-center text-4xl font-extrabold"
                springOptions={{
                  bounce: 0,
                  duration: 5000,
                }}
                value={Number(stat.number)}
              />
              <p className={"text-sm font-semibold text-muted-foreground"}>
                {stat.label}
              </p>
            </span>
          ))}
        </div>
      </div>
    </section>
  );
}
